import {createAsyncThunk} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {setValue} from "./reducers";
import {Playlist} from "../../api/types";

export const updateRecentlyPlayed = createAsyncThunk<void, Playlist, { state: RootState }>(
    'user/updateRecentlyPlayed',
    async (playlistToAdd, {dispatch, getState}) => {
        const {recentlyPlayed} = getState().user;

        let updatedRecentlyPlayed = { [playlistToAdd.id]: playlistToAdd, ...recentlyPlayed };

        if (Object.keys(updatedRecentlyPlayed).length > 10) {
            const entries = Object.entries(updatedRecentlyPlayed);
            const first10Entries = entries.slice(0, 10);
            updatedRecentlyPlayed = Object.fromEntries(first10Entries);
        }

        dispatch(setValue({key: 'recentlyPlayed', value: updatedRecentlyPlayed}));
    }
);

export type UserActions = ReturnType<
    typeof updateRecentlyPlayed
>;
